import { QueryClient } from "@tanstack/react-query";
import { authenticatedApi } from "api";

//<{queryKey: any, page: number, include: string}>
export const defaultQueryFn = async ({ queryKey, page = 1, include = 'default' }) => {
    const params = new URLSearchParams({
        page: page.toString(),
        include,
    });
    // console.log(params.toString());
    const { data } = await authenticatedApi.get(`/${queryKey[0]}?${params}`)

    return data;//.hasOwnProperty('data') ? data.data : data;
  }

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // refetchOnWindowFocus: true,
            queryFn: defaultQueryFn,
            retry: 2,
        },
    },
})
